// extracted by mini-css-extract-plugin
var _1 = "NPjFiepOak vI8xdh1gLj";
var _2 = "wVbOLpZoad";
export { _1 as "alert", _2 as "message" }
